export const showLoading = () => {
  const loading = document.getElementById('gm-loading')
  loading?.style.setProperty('display', 'flex')
}

export const hideLoading = () => {
  const loading = document.getElementById('gm-loading')
  loading?.style.setProperty('display', 'none')
}
